import { useCallback, useEffect, useState } from 'react';
import SaleService from '../../services/sale/saleService';

interface SalesTipSettings {
  tipEnabled: boolean;
  tipPercentage: number;
}

const DEFAULT_SETTINGS: SalesTipSettings = {
  tipEnabled: false,
  tipPercentage: 0,
};

/**
 * Configuración de propina opcional de POS para una sucursal.
 * Se usa para decidir si el checkbox "Cobrar propina" debe mostrarse en el
 * encabezado de la venta.
 */
export const useSalesTipSettings = (branchId?: number | null) => {
  const [settings, setSettings] = useState<SalesTipSettings>(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(false);

  const fetchSettings = useCallback(async () => {
    if (!branchId) {
      setSettings(DEFAULT_SETTINGS);
      return;
    }

    try {
      setLoading(true);
      const response = await SaleService.getTipSettings(branchId);

      if (response?.statusCode === 200 && response.data) {
        setSettings({
          tipEnabled: Boolean(response.data.tipEnabled),
          tipPercentage: Number(response.data.tipPercentage ?? 0),
        });
      }
    } catch {
      setSettings(DEFAULT_SETTINGS);
    } finally {
      setLoading(false);
    }
  }, [branchId]);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  return {
    tipEnabled: settings.tipEnabled,
    tipPercentage: settings.tipPercentage,
    loadingTipSettings: loading,
    refetchTipSettings: fetchSettings,
  };
};
